import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

/**
 * Dataset entity experience (v1 skeleton).
 *
 * Injects a dataset-specific "Overview" content tab into the standard Catalog
 * entity page, shown ONLY for kind:Resource with spec.type=dataset. marine-buv
 * stays a normal catalog entity; this content loads only when it matches.
 *
 * New Frontend System: EntityContentBlueprint comes from
 * @backstage/plugin-catalog-react/alpha; params use `path`/`title` (NOT the
 * deprecated defaultPath/defaultTitle), a lazy `loader`, and a `filter` string
 * predicate. Packaged with createFrontendModule and added to createApp features.
 */
const datasetOverviewContent = EntityContentBlueprint.make({
  name: 'dataset-overview',
  params: {
    path: '/dataset-overview',
    title: 'Overview',
    // Space-separated terms are ANDed; a comma ORs values within one term.
    // 'kind:resource,spec.type:dataset' parsed as kind in (resource,
    // spec.type:dataset) and put this tab on every Resource, including the
    // access lists (docnz-npcp-ro-access), whose storage card then failed.
    filter: 'kind:resource type:dataset',
    loader: () =>
      import('./DatasetOverviewContent').then(m => (
        <m.DatasetOverviewContent />
      )),
  },
});

/**
 * Lets the restore template offer a prefix instead of asking for one to be
 * typed, via `ui:field: DatasetPrefixPicker`. Registered on the scaffolder
 * plugin, not the catalog one - the form belongs to scaffolder.
 */
const datasetPrefixPicker = FormFieldBlueprint.make({
  name: 'dataset-prefix-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'DatasetPrefixPicker',
        schema: makeFieldSchema({ output: z => z.string() }),
        component: (await import('./DatasetPrefixPicker')).DatasetPrefixPicker,
      }),
  },
});

export const datasetModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [datasetOverviewContent],
});

export const datasetScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [datasetPrefixPicker],
});
